module.exports = __webpack_public_path__ + "images/backgrounds/snow/large.a98c66688311e2364f90.jpg";